import { render, staticRenderFns } from "./completeness.vue?vue&type=template&id=e2a254c2&scoped=true&"
import script from "./completeness.vue?vue&type=script&lang=js&"
export * from "./completeness.vue?vue&type=script&lang=js&"
import style0 from "./completeness.vue?vue&type=style&index=0&id=e2a254c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a254c2",
  null
  
)

export default component.exports